import styled from 'styled-components';
import { themeGet, getBackgroundColor } from '@magalu/stereo-ui-styles';
export const Container = styled.a`
  position: relative;
  cursor: pointer;
`;
export const Content = styled.div`
  background-color: ${props => getBackgroundColor('lighter')(props)};
  border-radius: 6px;
  padding: 10px;
  width: 190px;
  display: ${props => props.open ? 'flex' : 'none'};
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  top: 110%;
  right: 0px;
  position: absolute;
  z-index: ${props => themeGet('zIndices.0')(props)};
  box-shadow: ${props => themeGet('elevations.4')(props)};
`;
export const Circle = styled.a`
  background-color: ${props => getBackgroundColor('primary')(props)};
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  & > svg {
    width: 16px;
  }
`;